import { myget, mypost } from './index'

// 获取服务商角色列表
export const getAgentRoleList = (data) => {
    return mypost('/agent/role/list', data)
}
// 通过城市获取区
export const getArea = (data) => {
    return mypost('/agent/area/find', data)
}
// 添加服务商角色
export const addAgentRole = (data) => {
    return mypost('/agent/role/add', data)
}
// 获取服务商列表
export const getAgentList = (data) => {
    return mypost('/agent/list', data)
}
// 添加服务商
export const addAgent = (data) => {
    return mypost('/agent/add', data)
}
// 更新用户是否关闭
export const updateIsClose = (data) => {
    return mypost('/agent/updateIsClose', data)
}
// 更新服务商
export const updateAgent = (data) => {
    return mypost('/agent/update', data)
}
// 删除服务商
export const deleteAgent = (data) => {
    return mypost('/agent/delete', data)
}
// 获取服务商订单
export const getAgentOrderList = (data) => {
    return mypost('/agent/order', data)
}
// 获取城市数据
export const getAgentCityList = () => myget('/agent/city/list')
// 获取服务商订单
export const getAgentAreaList = (data) => {
    return mypost('/agent/area/list', data)
}
// 添加区
export const addAgentArea = (data) => {
    return mypost('/agent/area/add', data)
}

// diy页面
export const getData = (data) => {
    return myget('/agent/commission/list', data)
}


// diy页面
export const formPost = (data) => {
    return mypost('/users/finish_order', data)
}
